import 'reflect-metadata';
import './fix'
import { createApp } from 'vue'
import router from './routers'
import App from './App.vue'
import './assets/style/main.scss'
import '@patsnap-biz/design-tokens/scss/_variables-IP.css';
import './assets/style/el-overwrites.scss'
import { startup } from '@eureka/startup'
import { i18n, loadI18n } from '@/infrastructure/locales'
import { container } from './inversify.config';
import { setContainer, injectService } from '@patsnap/tahiti-core/ioc/inject';
import { HeaderServiceProxy } from './services/header-service-proxy'
import { ErrorHandler } from '@patsnap/tahiti-core/common/error-handler';
import { ErrorHandlerRegistry } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { AnonymousError } from '@eureka/services/src/exception';
import { accountDeferred } from '@eureka/utils/account';
import { injectFingerprintInterceptor } from '@eureka/services/src/apis/interceptors/fingerprint.interceptor';
import { SafeHtmlPlugin } from '@eureka/shared/safe-html-plugin';
import { openLoginDialog } from '@eureka/shared/login-iframe';
import { TrackService } from '@/domains/shared/services/track-service';
import { getAiccTaskIdFromQuery } from '@/presentation/utils/aicc-event-tracking';
import { trackAiccGuestToLogin } from '@/presentation/utils/aicc-login-tracking';

/**
 * 编译时常量声明
 */
declare const __ENABLE_FEISHU_CLIENT__: boolean | undefined;

setContainer(container);
injectService<ErrorHandler>(ErrorHandler).onStart();
injectService<ErrorHandlerRegistry>(ErrorHandlerRegistry).onStart();
injectFingerprintInterceptor();

const headerServiceInstance = injectService<HeaderServiceProxy>(HeaderServiceProxy).headerService as HeaderServiceProxy['headerService'];

// 配置登录处理器
headerServiceInstance.loginHandler = () => {
    console.log('[DEBUG] loginHandler called');
    const currentPath = router.currentRoute.value.path;
    const taskId = getAiccTaskIdFromQuery(router.currentRoute.value.query);
    if (currentPath.startsWith('/essentiality-claim')) {
        trackAiccGuestToLogin(
            injectService<TrackService>(TrackService),
            currentPath,
            taskId
        );
    }
    openLoginDialog();
};

startup({
    headerService: headerServiceInstance,
    projectName: 'eureka',
    preset: {
        name: 'eureka',
        preRedirectLogin() {
            // 退出登录后不弹登录弹窗，直接进入游客模式
            throw new AnonymousError();
        },
    },
    pageInit() {
        return Promise.resolve()
    },
});

(async() => {
    await loadI18n();
    const app = createApp(App);
    app.config.throwUnhandledErrorInProduction = true;
    app.use(router).use(i18n).use(SafeHtmlPlugin).mount('#app');
    accountDeferred.promise.then(
        async() => {
            // 通过编译时常量实现 Tree Shaking，仅 home + CN 环境检测飞书
            let isFeiShu = false;
            if (__ENABLE_FEISHU_CLIENT__) {
                const { clientDeferred } = await import('@eureka/startup/src/feishu-sdk');
                const result = await clientDeferred.promise;
                isFeiShu = result.isFeiShu;
            }
            if (isFeiShu) return;
            import('@eureka/startup/src/help-center').then(({ getHelpCenter }) => {
                getHelpCenter(i18n.global, headerServiceInstance)
            })
        }
    );
})()
